import { AddOnDto, AddOnDtoTypeEnum } from "../generated/dashboard-client";
import {
  DEFAULT_ADDON_PRICE, DESCRIPTION_DESIGN_ANNUAL, DESCRIPTION_DESIGN_MONTHLY, DESCRIPTION_PRO_ANNUAL, DESCRIPTION_PRO_MONTHLY,
  PRICE_DESIGN_ANNUAL,
  PRICE_DESIGN_MONTHLY,
  PRICE_PRO_ANNUAL,
  PRICE_PRO_MONTHLY, SUBTITLE_DESIGN_ANNUAL, SUBTITLE_DESIGN_MONTHLY,
  SUBTITLE_PRO_ANNUAL, SUBTITLE_PRO_MONTHLY
} from "../util/constants";
import { PlanLength, PlanType } from "../util/types";

export function getAddonsFriendlyLabel(addons: AddOnDto[]): string {
  const locationAddon = addons.find(
    (it) => it.type === AddOnDtoTypeEnum.Location
  );
  let label = "";

  if (locationAddon) {
    const addonQty = locationAddon.quantity || 1;
    if (label) label += ", ";
    label += `${addonQty} Location${addonQty > 1 ? "s" : ""}`;
  }

  return label;
}

export function getAddonsRecurringCharge(addons: AddOnDto[], type: AddOnDtoTypeEnum, deactivatedDevices: number): number {
  let charge = 0;
  addons
    .filter(it => it.type === type)
    .forEach((a) => {
    charge += (a.total || 0) * ((a.quantity || 0) - deactivatedDevices);
  });
  return charge;
}

export function getUserAddonPrice(availableAddons: AddOnDto[]): number {
  return getAddonPrice(availableAddons, AddOnDtoTypeEnum.Location);
}

export function getLocationAddonPrice(availableAddons: AddOnDto[]): number {
  return getAddonPrice(availableAddons, AddOnDtoTypeEnum.Location);
}

export function getAddonPrice(
  availableAddons: AddOnDto[],
  type: AddOnDtoTypeEnum
): number {
  let price = DEFAULT_ADDON_PRICE;
  const addon = availableAddons.find((it) => it.type === type);
  if (addon) {
    price = addon.total || DEFAULT_ADDON_PRICE;
  }
  return price;
}

export function getPlanPrice(planType: PlanType, planLength: PlanLength): string {
  if (planType === "pro" && planLength === 'annual') return PRICE_PRO_ANNUAL;
  if (planType === "pro" && planLength === 'monthly') return PRICE_PRO_MONTHLY;
  if (planType === "design" && planLength === 'annual') return PRICE_DESIGN_ANNUAL;
  if (planType === "design" && planLength === 'monthly') return PRICE_DESIGN_MONTHLY;

  return "";
}

export function getPlanSubtitle(planType: PlanType, planLength: PlanLength): string {
  if (planType === "pro" && planLength === 'annual') return SUBTITLE_PRO_ANNUAL;
  if (planType === "pro" && planLength === 'monthly') return SUBTITLE_PRO_MONTHLY;
  if (planType === "design" && planLength === 'annual') return SUBTITLE_DESIGN_ANNUAL;
  if (planType === "design" && planLength === 'monthly') return SUBTITLE_DESIGN_MONTHLY;

  return "";
}

export function getPlanDescription(planType: PlanType, planLength: PlanLength): string {
  if (planType === "pro" && planLength === 'annual') return DESCRIPTION_PRO_ANNUAL;
  if (planType === "pro" && planLength === 'monthly') return DESCRIPTION_PRO_MONTHLY;
  if (planType === "design" && planLength === 'annual') return DESCRIPTION_DESIGN_ANNUAL;
  if (planType === "design" && planLength === 'monthly') return DESCRIPTION_DESIGN_MONTHLY;

  return "";
}
